import { Component, input, Input, ChangeDetectionStrategy } from '@angular/core';

import { GridComponent, SectionComponent } from '@sirius/common';
import { FormImageComponent } from '../form-image/form-image.component';
import { StoryblokImage } from 'matchmaking/models';

@Component({
    selector: 'matchmaking-form-content',
    imports: [FormImageComponent, GridComponent, SectionComponent],
    templateUrl: './form-content.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-content.component.scss'
})
export class FormContentComponent {
    contentImage = input.required<StoryblokImage>();
}
